module.exports = __webpack_public_path__ + "img/tiempo.f0a5e98a.png";